export enum DragDropMode {
  HELPDESK = 'Helpdesk',
  SELF_SERVE = 'Self-Serve',
}
